import { Checkbox } from 'ccs-ui-components';
import { Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SERVICE_TYPE_KEY_VALUE } from '../../../../../constants';
import { useSelector } from '../../../../../store/AppStore';
import classes from './CheckBox.module.scss';

interface ICheckBoxProps {
  handleCheckBoxChange:()=> void;
  serviceTypeValue: string | undefined

}
const CheckBox = ({
  handleCheckBoxChange,
  serviceTypeValue
}: ICheckBoxProps) => {
  const { t: translate } = useTranslation();
  const { checkClicked } = useSelector((state) => state.serviceDetailsReducer);
  return (
    <Row>
      {(serviceTypeValue === SERVICE_TYPE_KEY_VALUE.REST
      || serviceTypeValue === SERVICE_TYPE_KEY_VALUE.MQ) && (
        <Form.Group className="mb-3" controlId="formAuthCheck">
          <Checkbox
            type="checkbox"
            label={translate('service_details_form_component.lbl_provide_auth_details')}
            onChange={handleCheckBoxChange}
            checked={checkClicked}
            data-testid="provide-auth-details-check"
            disabled={serviceTypeValue === SERVICE_TYPE_KEY_VALUE.DB2}
          />
        </Form.Group>)}
      {(serviceTypeValue === SERVICE_TYPE_KEY_VALUE.DB2) && (
      <div className={classes.credentials}>{translate('service_details_form_component.lbl_credentials')}</div>)}
    </Row>
  );
};

export default CheckBox;
